// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1c92K","title":"FrontImage_title__32Pes"};